export default class RequiredFieldPossibleValue {

    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.displayValue = jsonResponse["display-value"];
        this.value = jsonResponse["value"];
        this.brandRequiredFieldId = jsonResponse["brand-required-field-id"];
    }

    static toJson = function (obj) {
        let jsonObj = {};
        jsonObj["id"] = obj.id;
        jsonObj["display-value"] = obj.displayValue;
        jsonObj["value"] = obj.value;
        jsonObj["brand-required-field-id"] = obj.brandRequiredFieldId;
        return jsonObj;
    };
}
